import React from 'react';
import { render } from 'react-dom';
import { App as PropulsionApp } from '@ui-propulsion/react-components';
import dynamicModuleRegistry from 'dynamic-module-registry';
import PopupAgreement from './components/Popup';
import '@shared_modules/propulsion/core/styles.scss';
const componentProps = dynamicModuleRegistry.get('componentProps');

render(
  <PropulsionApp>
    <PopupAgreement {...componentProps} />
  </PropulsionApp>,
  document.getElementById('popup')
);

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/pages/popup/popup.scss');